import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const PUNTI = [
  "Fatturazione elettronica completa: XML ufficiale controllato, invio e ricezione dallo SdI",
  "Preventivi, ordini, DDT, note di credito e acquisti",
  "Funzioni dedicate ai forfettari: limite ricavi, reddito con coefficiente ATECO, imposta sostitutiva e contributi INPS stimati",
  "Cassa e corrispettivi telematici integrati",
];

export const ForfettariPromo = () => (
  <section className="border-b border-slate-200 bg-[#0B132B] text-white" data-testid="forfettari-promo">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr] lg:items-center">
      <div>
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-sky-300">Offerta forfettari</div>
        <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-testid="forfettari-title">
          Fattura elettronica per forfettari a <span className="text-sky-300">4 €/mese</span>. Tutto incluso, zero pensieri.
        </h2>
        <ul className="mt-8 space-y-3 text-sm text-slate-200">
          {PUNTI.map((t) => <li key={t} className="flex items-start gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />{t}</li>)}
        </ul>
      </div>
      <div className="rounded-2xl border border-white/10 bg-white/5 p-7 backdrop-blur">
        <p className="text-base font-semibold">Offerta a te dedicata: fatturazione elettronica, cassa e corrispettivi telematici e tante altre funzionalità.</p>
        <Button asChild size="lg" className="mt-6 h-12 w-full bg-sky-500 text-base font-bold text-[#020617] hover:bg-sky-400" data-testid="forfettari-cta">
          <Link to="/prova?offerta=forfettari">INIZIA GRATIS ORA <ArrowRight className="ml-2 h-4 w-4" /></Link>
        </Button>
        <p className="mt-4 text-sm text-slate-300">Prova FatturazioneGestionale gratis per 30 giorni e senza impegno, poi lo acquisti a <b className="text-white">4 €/mese</b>.</p>
        <p className="mt-4 text-xs leading-relaxed text-slate-400" data-testid="forfettari-condizioni">L'offerta è riservata ai nuovi clienti ed è valida solo per il primo anno. Per usufruirne è necessario registrarsi e completare la configurazione, indicando l'appartenenza al regime forfettario.</p>
      </div>
    </div>
  </section>
);
